import { useEffect, useRef, useState } from "react";
import useAPIRequest from "../simple/useAPIRequest";
import onErrorToast from "../../utils/OnErrorToast";
import createFilterText from "../../utils/CreateFilterText";

const useSelectorDialogControl = ({
  apiName,
  orderBy,
  orderMethod,
  additionalParams,
}) => {
  const [paging, setPaging] = useState({
    page: 1,
    take: 8,
    filter: "",
    total: 0,
    ...additionalParams,
  });
  const toast = useRef(null);
  const [listData, setListData] = useState([]);
  const [selectedRows, setSelectedRows] = useState({});

  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest({
      url: `api/${apiName}`,
    });

  const reloadListData = async ({ page, take, filter }) => {
    if (loading) return;

    await requestGet({
      apiUrl: `data`,
      params: {
        page: page,
        take: take,
        filter: filter,
        order: orderBy,
        order_method: orderMethod,
        ...additionalParams,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: pagination["filter"],
        });
        setListData(data);
      },
      onError: ({ message, data }) => {
        console.log("ERROR", message);
        onErrorToast({ toast: toast, message: message, data: data });
      },
    });

    return;
  };

  useEffect(() => {
    reloadListData({ page: 1, take: 8, filter: "" });
  }, []);

  const handleOnFilter = (filterMap) => {
    const filterString = createFilterText(filterMap);
    setPaging({ ...paging, filter: filterString });
    reloadListData({
      page: paging.page,
      take: paging.take,
      filter: filterString,
    });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    reloadListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const refineValue = (newValue) => {
    if (newValue.length > 0) {
      let nullCount = 0;
      for (const v of newValue) {
        if (v === null) {
          nullCount++;
        }
      }
      if (nullCount === newValue.length) {
        return [];
      }
    }
    return newValue;
  };

  const handleSelectionChange = (values) => {
    if (Array.isArray(values)) {
      setSelectedRows([...values]);
    } else if (typeof values === "object") {
      setSelectedRows([values]);
    } else {
      setSelectedRows([]);
    }
  };
  return {
    // UIs
    toast,
    // States
    listData,
    paging,
    setPaging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    // Methods
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
  };
};

export default useSelectorDialogControl;
